module.exports = __webpack_public_path__ + "img/card-FMCG1.ca38fa47.svg";